import { render, staticRenderFns } from "./FactorBaseReveal.vue?vue&type=template&id=ef86a846&scoped=true"
import script from "./FactorBaseReveal.vue?vue&type=script&lang=js"
export * from "./FactorBaseReveal.vue?vue&type=script&lang=js"
import style0 from "./FactorBaseReveal.vue?vue&type=style&index=0&id=ef86a846&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef86a846",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef86a846')) {
      api.createRecord('ef86a846', component.options)
    } else {
      api.reload('ef86a846', component.options)
    }
    module.hot.accept("./FactorBaseReveal.vue?vue&type=template&id=ef86a846&scoped=true", function () {
      api.rerender('ef86a846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/FactorBaseReveal.vue"
export default component.exports